import { createFileRoute } from '@tanstack/react-router'

import { preloadListPointsOfSale } from '@/api/react-query'

export const Route = createFileRoute('/_authenticated/settings/points-of-sale')({
	loader: async ({ context }) => await preloadListPointsOfSale(context, {}),
	staticData: { crumb: ({ context: { L } }) => L.PointOfSale.Title() }
})
